export default __webpack_public_path__ + "locales/tr/OAuth.json?hash=fbd107d87509be6253244cc5d9bd557c";